module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown greek-symbol"
  }, [_vm._t("default"), _vm._v(" "), (_vm.isGreekCharactersAllowed) ? [_c('button', {
    attrs: {
      "id": 'dLabel' + _vm.lineId,
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n            Ω\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": 'dLabel' + _vm.lineId
    }
  }, [_c('h4', [_vm._v("Add these Greek letters")]), _vm._v(" "), _c('div', {
    staticClass: "row symbols-list"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "col-5"
    }, [_c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "value": letter
      },
      domProps: {
        "innerHTML": _vm._s(letter)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.onGreek(letter)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row no-gutter"
  }, [_c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onClear($event)
      }
    }
  }, [_vm._v("Clear")])])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-960abf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/greek-letters-dropdown.vue
// module id = lG2w
// module chunks = 1